import { useState, type FC } from 'react';

import { VSpacingContainer } from '@hh.ru/magritte-ui';

import AccountTypeSwitch from 'src/components/AccountLogin/components/AccountTypeSwitch/AccountTypeSwitch';
import Agreement from 'src/components/AccountLogin/components/Agreement/Agreement';
import { useSelector } from 'src/hooks/useSelector';
import { UserType } from 'src/models/userType';

import ApplicantLoginCard from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard';
import CommonApplicantLoginCard from 'src/components/AccountLogin/CombinedLoginCards/CommonApplicantLoginCard';
import EmployerLoginCard from 'src/components/AccountLogin/CombinedLoginCards/EmployerLoginCard';

const AccountLogin: FC = () => {
    const anonymousUserType = useSelector((state) => state.anonymousUserType);
    const loginTileType = useSelector((state) => state.loginTileType);
    const isForbiddenPage = useSelector((state) => state.forbidden);
    const isApplicant = anonymousUserType === UserType.Applicant;

    const [shouldShowAccountTypeSwitch, setShouldShowAccountTypeSwitch] = useState(!loginTileType);
    const [shouldShowAgreement, setShouldShowAgreement] = useState(isApplicant);

    if (isApplicant && !isForbiddenPage) {
        return <ApplicantLoginCard />;
    }

    const handleSignUp = (): void => {
        setShouldShowAgreement(false);
        setShouldShowAccountTypeSwitch(false);
    };

    const handleNextStep = (): void => {
        setShouldShowAccountTypeSwitch(false);
    };

    return (
        <VSpacingContainer default={24}>
            {isApplicant ? (
                <CommonApplicantLoginCard key="applicant_authorization" onSignUp={handleSignUp} />
            ) : (
                <EmployerLoginCard key="employer_authorization" onNextStep={handleNextStep} />
            )}
            {shouldShowAccountTypeSwitch && <AccountTypeSwitch />}
            {shouldShowAgreement && <Agreement isApplicant={isApplicant} />}
        </VSpacingContainer>
    );
};

export default AccountLogin;
